import { render, staticRenderFns } from "./consult-info23.vue?vue&type=template&id=311d8afa&scoped=true"
import script from "./consult-info23.vue?vue&type=script&lang=js"
export * from "./consult-info23.vue?vue&type=script&lang=js"
import style0 from "./consult-info23.vue?vue&type=style&index=0&id=311d8afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d8afa",
  null
  
)

export default component.exports